module.exports = function getResource(label, vars = []) {
    const resources = {
        addFullSize: 'Ajouter le produit en format standard',
        addToBasket: 'Ajouter au panier',
        add: 'Ajouter',
        remove: 'Supprimer',
        viewLarger: 'Agrandir'
    };

    return resources[label];
};
